import { addDays } from './addDays';
import { isTrainingMode } from './isTrainingMode';
import moment from 'moment';

/*
 * Filter outs flights that are to old or to new
 * the callXml function is used as callback
 **/
export const filterFlights = (flights) => {
  let filteredFlights = [];

  const trainingMode = isTrainingMode();

  if (trainingMode) {
    // In training mode, return all flights without time filtering
    for (let i = 0; i < flights.flt.length; i++) {
      filteredFlights.push(flights.flt[i]);
    }
    return filteredFlights;
  }

  // Window: keep flights whose STD is within the last 72 hours up to 2 days ahead (all in UTC)
  const nowUtc = moment.utc();
  const earliest = moment.utc(nowUtc).subtract(72, 'hours');
  const latest = moment.utc(nowUtc).add(2, 'days').endOf('day');

  for (let i = 0; i < flights.flt.length; i++) {
    const stdStr = flights.flt[i]?.sSTD?.[0] || '';
    // sSTD format: YYYY-MM-DD HH:mm (UTC)
    const std = stdStr ? moment.utc(stdStr, 'YYYY-MM-DD HH:mm') : null;
    if (!std || !std.isValid()) continue;

    if (std.isSameOrAfter(earliest) && std.isSameOrBefore(latest)) {
      filteredFlights.push(flights.flt[i]);
    }
  }
  return filteredFlights;
};
